export const formatVariableNames = (name: string) => {
  switch (name.toLowerCase()) {
    case 'created':
      return 'created at';
    case 'recipient id':
      return 'user id';
    case 'email open':
      return 'email opened';
    case 'email introduce to sale':
      return 'hot lead trigger';
    case 'email click':
      return 'email clicked';
    case 'source (old)':
      return 'source old';
    case 'email send':
      return 'email sent';
    case 'suppressed':
      return 'suppression list';
    case 'sms send':
      return 'sms sent';
    case 'estimated household income':
      return 'est. household income';
    case 'auto body type':
      return 'auto type';
    case 'lgbt supporters/donors':
      return 'LGBTQ+ Donor/Supporter';
    case 'credrate':
      return 'credit rating';
    case 'singparent':
      return 'single parent';
    case 'nascar':
      return 'NASCAR';
    case 'zip':
      return 'ZIP';
    case 'childrens products':
      return 'children products';
    case 'eu limits detected at':
      return 'EU limits detected at';
    case 'ctm ad id':
      return 'CTM ad id';
    case 'ctm ad name':
      return 'CTM ad name';
    case 'ctm ad set name':
      return 'CTM ad set name';
    case 'ctm campaign name':
      return 'CTM campaign name';
    default:
      return name;
  }
};

export const normalizeVariableName = (variableName: string) => {
  const prefixes = ['VOY_', 'LD_'];
  const suffix = '(LD)';
  let value = variableName;
  value = prefixes.reduce(
    (acc, prefix) => (acc.startsWith(prefix) ? acc.slice(prefix.length) : acc),
    variableName,
  );

  if (value.endsWith(suffix)) {
    value = value.slice(0, -suffix.length);
  }

  const normalizedName = value.replace(/_/g, ' ')?.toLowerCase()?.trim();

  return formatVariableNames(normalizedName);
};

export const hiddenVariables = [
  'sessions count',
  'last active',
  'email reply',
  'wday',
  'suppression_list_include',
  'suppression list include',
  'email reply',
  'ld perm individual id',
  'fb messenger user id',
];
